import styled from "styled-components";

import { media } from "../../../styles/media";

export const EditBusinesProfileFormStyles = styled.div`
  .formContainer {
    display: flex;
    justify-content: space-between;

    .leftInputs {
      width: 390px;
    }

    .rightInputs {
      width: 390px;

      .stateDropdown {
        background: #fafbfc;
        border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
      }
    }

    /* After the base rules so the full-width override wins by source order. */
    ${media.maxMobile`
      flex-direction: column;
      gap: 16px;

      .leftInputs,
      .rightInputs {
        width: 100%;
      }
    `}
  }

  .buttonContainer {
    display: flex;
    justify-content: flex-end;
  }
`;
